import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import LoginHOC from '../auth/LoginHOC'
import { connect } from 'react-redux'
import { setAccessToken, logout, clearRedirectTo } from '../redux/actions'
import Checkbox from '../elements/Checkbox'
import InputRow from '../elements/InputRow'
import globals from '../globals'

const options = {
    postUrl: '/api/auth/postLogin',
    success: 'Login successful! Redirecting you to My Exetel.'
}
const state = {
    username: '',
    password: '',
    persistLogin: false
}

const LoginForm = (props) => {
    const handlePersistLogin = (value) => {
        props.setDynamicValues({ persistLogin: value })
        if (value) {
            globals.pushEvent('PersistLoginChecked')
        }
    }

    return (
        <form onSubmit={props.handleSubmit} onKeyDown={props.handleKeyDown}>
            <InputRow
                label='Username'
                name='username'
                value={props.values.username}
                errors={props.errors}
                handleChange={props.handleInputChange}
                autoComplete='username'
                placeholder='Username'
                type='email'
            />
            <InputRow
                label='Password'
                name='password'
                value={props.values.password}
                errors={props.errors}
                handleChange={props.handleInputChange}
                autoComplete='current-password'
                placeholder='Password'
                type='password'
            />

            <Checkbox
                name='persistLogin'
                value={props.values.persistLogin}
                errors={props.errors}
                handleClick={handlePersistLogin}
            >Keep me logged in on this device
            </Checkbox>

            {props.children}

            <div className='mt-4'>
                <Button title='Login' action={props.handleSubmit} />
            </div>
        </form>
    )
}

const mapStateToProps = state => ({
    id: state.auth.id,
    firstName: state.auth.firstName,
    fullName: state.auth.fullName,
    redirectTo: state.auth.redirectTo
})

export default connect(mapStateToProps, { setAccessToken, logout, clearRedirectTo })(LoginHOC(FormHOC(LoginForm, state, options)))



// WEBPACK FOOTER //
// ./resources/js/forms/LoginForm.js